import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { LinkType } from '../../types';
import Typography from '../typography/Typography';
import Stack from '../stack/Stack';
import Link from '../link/Link';
import { formatForID } from '../../utils';

// Interface

export interface ActionBlockProps {
  heading?: string;
  subHeading?: string;
  centered?: boolean;
  link: LinkType;
}

// Styles

export interface StyledActionBlockProps {
  centered?: boolean;
}

export const StyledActionBlock = styled(Stack)<StyledActionBlockProps>`
  ${({ theme: { media, maxMedia }, centered }) => css`
    text-align: ${centered ? 'center' : 'left'};

    a {
      display: inline-flex;
    }

    @media (min-width: ${media.medium}) {
      margin-left: ${centered ? 'auto' : '0'};
      margin-right: ${centered ? 'auto' : '0'};

      h3,
      p {
        text-wrap: balance;
      }
    }

    ${centered &&
    css`
      @media (max-width: ${maxMedia.medium}) {
        h3,
        p {
          text-wrap: balance;
        }
      }
    `};
  `}
`;

// JSX

export const ActionBlock: FC<ActionBlockProps> = ({
  heading,
  subHeading,
  centered,
  link,
  ...rest
}) => (
  <StyledActionBlock gap="xSmall" centered={centered} id={heading? formatForID(heading) : ''} {...rest}>
    <Typography component="h3" variant="headingSmall">
      {heading}
    </Typography>
    {subHeading && (
      <Typography component="p" variant="bodyToLarge">
        {subHeading}
      </Typography>
    )}
    {link && (
      <Link {...link} dataLayerClickContext={`Action block - ${heading}`} />
    )}
  </StyledActionBlock>
);

export default ActionBlock;
